
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/more/nextra-theme-mui-docs",
      function () {
        return require("private-next-pages/more/nextra-theme-mui-docs.mdx");
      }
    ]);
  